export default __webpack_public_path__ + "static/media/prizecup.85ef8ad7.svg";